export default "__VITE_ASSET__20230e0f__"